import { render, staticRenderFns } from "./AddFinanceAccount.vue?vue&type=template&id=67f0f01c&scoped=true"
import script from "./AddFinanceAccount.vue?vue&type=script&lang=js"
export * from "./AddFinanceAccount.vue?vue&type=script&lang=js"
import style0 from "./AddFinanceAccount.vue?vue&type=style&index=0&id=67f0f01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0f01c",
  null
  
)

export default component.exports